export default "__VITE_ASSET__D6Xe7Dig__"